import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { alpha, useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import { createNewPractice } from "../../data/omniDataModel";
import * as AdminSessionActions from "../../state/redux/adminSession";
import * as PracticeActions from "../../state/redux/practiceSession";
import { capitalizeAllWords } from "../../utils/helpers";
import { deepCopyObject } from "../../utils/helpers";
import PracticeDialog from "../dialogs/practiceDialog";
import OmniResponsiveButton from "../ui/omniResponsiveButton.js";
import Widget from "../ui/widget";
import WidgetList from "../ui/widgetList";
import WidgetSkeleton from "../ui/widgetSkeleton";
import WidgetTitle from "../ui/widgetTitle";

const AdminPractices = props => {
  const { practiceODMs } = props;

  const [selectedPractice, setSelectedPractice] = useState(null);

  useEffect(() => {
    if (practiceODMs == null) {
      props.loadPracticesRequest();
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [practiceODMs]);

  const [titleText, setTitleText] = useState(null);

  useEffect(() => {
    if (practiceODMs != null) {
      setTitleText(`${practiceODMs.length} Active`);
    } else {
      setTitleText("Loading...");
      props.loadPracticesRequest();
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [practiceODMs]);

  const theme = useTheme();

  return (
    <Widget>
      <WidgetTitle title={"Practices"} text={titleText} loading={practiceODMs == null}>
        <OmniResponsiveButton
          tooltipTitle="Create a new practice"
          buttonText="Practice"
          onClick={() => {
            setSelectedPractice(createNewPractice);
          }}
        />
      </WidgetTitle>

      {practiceODMs == null && <WidgetSkeleton />}
      {practiceODMs != null && (
        <WidgetList>
          {practiceODMs
            .sort((a, b) => a.omniData.name.localeCompare(b.omniData.name))
            .map((practice, index) => {
              return (
                <ListItem
                  key={`assessment${index}`}
                  disableGutters={true}
                  sx={{
                    padding: theme.spacing(1),
                    paddingTop: 0,
                    paddingBottom: 0,
                    marginBottom: theme.spacing(1),
                    borderRadius: theme.spacing(1),
                    backgroundColor: alpha(theme.palette.info.main, 0.75),
                    color: theme.palette.info.contrastText,
                    boxShadow: theme.shadows[3],
                    userSelect: "none",
                    webkitUserSelect: "none",
                  }}
                  onClick={e => {
                    e.stopPropagation();
                    setSelectedPractice(practice);
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography
                        variant="h6"
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          marginLeft: theme.spacing(1),
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          color: theme.palette.info.contrastText,
                          marginTop: 0,
                        }}
                      >
                        {`${practice.omniData.name}`}
                      </Typography>
                    }
                    secondary={
                      <Typography
                        variant="body2"
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          marginLeft: theme.spacing(1),
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          marginTop: "-6px",
                          color: theme.palette.info.contrastText,
                          minimumHeight: 20,
                        }}
                      >
                        {`${
                          practice.omniData.practiceType
                            ? capitalizeAllWords(practice.omniData.practiceType) + " Practice"
                            : "No Info"
                        }`}
                      </Typography>
                    }
                  />
                </ListItem>
              );
            })}
        </WidgetList>
      )}
      {selectedPractice && (
        <PracticeDialog
          open={selectedPractice != null}
          dialogTitle={"Create Practice"}
          omniDMO={deepCopyObject(selectedPractice)}
          fullWidth={true}
          onDelete={selectedPractice_id => {
            props.deletePracticeRequest(selectedPractice_id);
            setSelectedPractice(null);
          }}
          onAccept={selectedPractice => {
            props.updatePracticeRequest(selectedPractice);
            setSelectedPractice(null);
          }}
          onClose={() => {
            setSelectedPractice(null);
          }}
        />
      )}
    </Widget>
  );
};

const mapStateToProps = state => ({
  practiceODMs: state.adminSession.practiceODMs,
});

const mapDispatchToProps = {
  loadPracticesRequest: AdminSessionActions.loadPracticesRequest,

  deletePracticeRequest: PracticeActions.deletePracticeRequest,
  updatePracticeRequest: PracticeActions.updatePracticeRequest,
  setPracticeODMRequest: PracticeActions.setPracticeODMRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AdminPractices));
